import clsx from "clsx/lite";
import React from "react";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";

const Dropdown = ({
	Preview, onChange, value, className = "", activeClass = "",
	hideArrow = false, children, id, name, label
}) => (
	<div className={clsx(className, "relative focus-within:outline focus-within:!outline-beige")}>
		<div className={clsx(activeClass, "flex items-center justify-between border p-2")}>
			<div className="flex gap-3 items-center w-full">
				<Preview />
			</div>
			{!hideArrow && <Arrow className="rotate-90 float-right" />}
		</div>
		<div className="opacity-0 absolute z-10 top-0 w-full">
			<select
				className="p-2 bg-transparent w-full cursor-pointer appearance-none"
				onChange={onChange}
				defaultValue={value}
				id={id}
				name={name}
				aria-label={label || "Dropdown"}
			>
				{children}
			</select>
		</div>
	</div>
);

export default Dropdown;